// ----------------------------------------------------------------------

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

// ----------------------------------------------------------------------

const FONT_HEADINGS = 'Trench, sans-serif';
const FONT_BODY = 'Barlow, sans-serif';

const typography = {
  fontFamily: FONT_BODY,

  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,

  h1: {
    fontFamily: FONT_HEADINGS,
    fontWeight: 300,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontFamily: FONT_HEADINGS,
    fontWeight: 300,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontFamily: FONT_HEADINGS,
    fontWeight: 300,
    lineHeight: 1.4,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontFamily: FONT_HEADINGS,
    fontWeight: 300,
    lineHeight: 1.4,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontFamily: FONT_HEADINGS,
    fontWeight: 300,
    lineHeight: 1.4,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: FONT_HEADINGS,
    fontWeight: 300,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },

  subtitle1: {
    fontFamily: FONT_BODY,
    fontWeight: 400,
    lineHeight: 1.55,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontFamily: FONT_BODY,
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },

  body1: {
    fontFamily: FONT_BODY,
    fontWeight: 400,
    lineHeight: 1.65,
    fontSize: pxToRem(18),
  },
  body2: {
    fontFamily: FONT_BODY,
    fontWeight: 400,
    lineHeight: 1.65,
    fontSize: pxToRem(16),
  },
  caption: {
    fontFamily: FONT_BODY,
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontFamily: FONT_BODY,
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
    letterSpacing: 0.8,
  },
  button: {
    fontFamily: FONT_BODY,
    fontWeight: 600,
    lineHeight: 24 / 14,
    fontSize: pxToRem(16),
    textTransform: 'none',
  },
};

export default typography;